import * as React from 'react';
import CKEditorComponent from './wrapper';
import { IButton, ICommand } from './wrapper';
export { IButton, ICommand };
import { translate } from 'react-i18next';
import { IUserPreferences } from 'models/user/userpreferences';
const classNames = require('classnames');
const editorCss = require('-!file-loader!./style.css');

interface IProps {
	input?: any;
	label?: any;
	meta?: any;
	baseAPI?: string;
	description?: string;
	maxLength?: number;
	userPreferences: IUserPreferences;
	addButtons?: IButton[];
	addCommands?: ICommand[];
	height?: number;
	token: string;
	className?: string;
	serif?: boolean;
}

class CKEditor extends React.Component<IProps, {}> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { input, addButtons, addCommands, height } = this.props;
		const { isAdministrator, isEditor } = this.props.userPreferences;

		let description: string | string[] = this.props.description || '';
		let status = '';
		if (this.props.meta?.touched) {
			if (this.props.meta?.warning) {
				status = 'withWarning';
				description = this.props.meta.warning;
			}
			if (this.props.meta?.error) {
				description = this.props.meta.error;
				status = 'withError';
			}
		}

		if (this.props.maxLength) {
			const maxLength = Number(this.props.maxLength);
			const value = String(this.props.input?.value || '');
			if (value.length > maxLength) {
				description = translate('Validation_Field_TooLong');
				status = 'withError';
			} else if (value.length <= maxLength) {
				description = [description as string, value.length + '/' + maxLength];
			}
		}

		const config: any = {
			extraPlugins: 'easyimage,placeholder,embed,autoembed',
			removePlugins: 'image',
			cloudServices_uploadUrl: this.props.baseAPI + 'api/EditorImageUpload/' + this.props.token,
			cloudServices_tokenUrl: this.props.baseAPI + 'api/imagetoken/GetImageToken',
			imageUploadUrl: this.props.baseAPI + 'api/EditorImageUpload/' + this.props.token,
			bodyClass: this.props.serif ? 'serif' : 'sans-serif',
			easyimage_toolbar: ['EasyImageFull', 'EasyImageAlignLeft', 'EasyImageAlignRight'],
			height: height || '869',
			toolbar: [
				{
					name: 'paragraph',
					items: [
						'Format',
						'Blockquote',
						'Link',
						'EasyImageUpload',
						'NumberedList',
						'BulletedList',
						'Bold',
						'Italic',
						'Underline',
						'Embed',
					],
				},
			],
			toolbarGroups: [
				// { name: 'basicstyles', groups: [ 'styles', 'basicstyles', 'blocks', 'links', 'list', 'insert' ] },
			],
			format_tags: 'p;h2;h3;h4',
			// removeButtons: 'Unlink,Source,Flash,Table,HorizontalRule,Smiley,SpecialChar,Anchor,Strike,Subscript,Superscript,Styles,Templates,Scayt,CreateDiv,Flash,Smiley,PageBreak,Iframe,Font,FontSize,ShowBlocks,NewPage,Preview,Print,Underline,Bold,Italic,Placeholder,ExportToPDF',
			contentsCss: editorCss,
			linkShowAdvancedTab: false,
			linkShowTargetTab: false,
			forcePasteAsPlainText: true,
			editorplaceholder: this.props.label,
			uiColor: '#FFFFFF',
			embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
			// autoEmbed_widget : 'customEmbed',
		};

		if (isAdministrator || isEditor) {
			config.allowedContent = true;
		}

		let editor: any = null;
		if (this.props.token) {
			editor = (
				<CKEditorComponent
					{...input}
					className={'inputField' + (input?.value ? ' value' : '')}
					content={input?.value || ''}
					events={{
						change: (evt: any) => {
							input.onChange(evt.editor.getData());
						},
						instanceReady: (evt: any) => {
							var CKEditor = evt.editor;

							CKEditor.on('fileUploadResponse', (evt) => {
								setTimeout(() => {
									evt.editor.setData(evt.editor.getData() + ' '); // we have to set the data again after a small timeout to trigger the change event so that images are saved correctly (because of BUG-7708)
								}, 50);
								evt.stop(); // we stop the default response handling
							});
						},
					}}
					config={config}
					scriptUrl="https://cdn.ckeditor.com/4.15.1/full-all/ckeditor.js"
					addButtons={addButtons}
					addCommands={addCommands}
				/>
			);
		}

		return (
			<div className={classNames('ckeditor-holder fieldGroup', status, this.props.className)}>
				{editor}
				{description ? (
					<span className={'note' + (Array.isArray(description) ? ' split' : '')}>
						{Array.isArray(description) ? description.map((d, i) => <span key={i}>{d}</span>) : description}
					</span>
				) : null}
			</div>
		);
	}
}

export { CKEditor };
